import {
  createUserEndPoint,
  editUserProfileEndPoint,
  getUserEndPoint,
  getAllUserDetailsEndPoint,
} from "@/config/apiEndPoints";
import { APIGEE_CLIENT_KEY_DATA } from "../config/constant";

const getApprovers = (config, idToken) => {
  const { pageSize, pageOffset, filter, childRequired } = config;
  let parameter = `size=${pageSize}&page=${
    pageOffset / 30
  }&childRequired=${childRequired}&sort=userApmId,asc`;

  filter &&
    filter.forEach((item) => {
      Object.entries(item).forEach(([key, value]) => {
        parameter = `${parameter}&${key.trim()}=${value.trim()}`;
      });
    });

  return {
    method: "get",
    url: `${getAllUserDetailsEndPoint}?${parameter}`,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
  };
};

const createApprover = (payload, idToken) => {
  return {
    method: "post",
    url: createUserEndPoint,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
    data: payload,
  };
};

const updateApprover = (userApmId, payload, idToken) => {
  return {
    method: "patch",
    url: editUserProfileEndPoint(userApmId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
    data: payload,
  };
};

const getSingleApprovers = async (userApmId, idToken) => {
  return {
    method: "get",
    url: getUserEndPoint(userApmId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
  };
};

const deleteApprover = async (userApmId, idToken) => {
  return {
    method: "delete",
    url: getUserEndPoint(userApmId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
  };
};
export default {
  createApprover,
  updateApprover,
  getSingleApprovers,
  getApprovers,
  deleteApprover,
};
